import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Transition,
} from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/20/solid"
import { twMerge } from "tailwind-merge"

interface Props {
  text: string
  title: string
}

export default function FrequentlyAskedQuestion({ text, title }: Props) {
  return (
    <div className="theme-disclosure px-6 py-5">
      <Disclosure>
        {({ open }) => (
          <>
            <DisclosureButton className="flex w-full items-center justify-between gap-4 text-left">
              <span className="text-base font-semibold">{title}</span>

              <ChevronDownIcon
                className={twMerge(
                  "h-5 w-5 shrink-0 transition-transform duration-200",
                  open && "rotate-180",
                )}
              />
            </DisclosureButton>

            <div className="overflow-hidden">
              <Transition
                enter="duration-200 ease-out"
                enterFrom="opacity-0 -translate-y-6"
                enterTo="opacity-100 translate-y-0"
                leave="duration-300 ease-out"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 -translate-y-6"
              >
                <DisclosurePanel className="text-text-secondary mt-4 text-sm">
                  {text}
                </DisclosurePanel>
              </Transition>
            </div>
          </>
        )}
      </Disclosure>
    </div>
  )
}
